import React from "react";
import RequestsMerchant from "../modules/RequestsMerchant/RequestsMerchant";

export default function RequestsMerchantPage() {
  return <RequestsMerchant />;
}